import React, { useState, useRef, useEffect } from 'react';
import {
  ContainerCenter,
  ContainerCenterInside,
  MainContainer,
  TopDiv,
  Header,
  InputDiv,
} from './styles';
import Menu from '../../components/general/Menu';
import TopBar from '../../components/general/TopBar';
import Search from '../../assets/icons/Search';
import Input from '../../components/general/Input';

import ActiveIterable from './Iterable';
import { useOutsideDrop } from '../../hooks/useOutsideDrop';
import { useVerifyToken } from '../../hooks/useVerifyToken';
import { useDispatch, useSelector } from 'react-redux';

import { fetchFinishedFlows } from '../../state/finishedFlows/reducers';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { toastAlert } from '../../components/Toastify';

import { FinishedFlowsFilter } from './Filter';
import { useHistory } from 'react-router';
import Pagination from '../../components/general/Pagination/index';
import ReactLoading from 'react-loading';

const FinishedFlowsPage = ({ location }) => {
  //?Filter Block
  const [filterOpen, setFilterOpen] = useState(false);

  //url Params
  const params = new URLSearchParams(location.search);

  const [labelSearch, setLabelSearch] = useState(
    params.get('label') ? params.get('label') : ''
  ); //filtrar rótulo da tarefa

  const [clientSearch, setClientSearch] = useState(
    params.get('clientSearch') ? params.get('clientSearch') : ''
  ); //filtrar nome do cliente

  const [flowSearch, setFlowSearch] = useState(
    params.get('flowSearch') ? params.get('flowSearch') : ''
  ); //filtrar por projeto de fluxo

  const [typeFilter, setTypeFilter] = useState({
    title: params.get('title') ? params.get('title') : '',
    client: params.get('client') ? params.get('client') : '',
    alpha: params.get('alpha') ? params.get('alpha') === 'true' : false,
    creation: params.get('creation')
      ? params.get('creation') === 'true'
      : false,
    finishedAt: params.get('finishedAt')
      ? params.get('finishedAt') === 'true'
      : false,
    page: params.get('page') ? parseInt(params.get('page')) : 1,
  });

  const { promiseInProgress: isFetching } = usePromiseTracker({
    area: 'fetchFinishedFlows',
  });

  const updateFilters = ({ ...typeFilter }) => {
    setTypeFilter({ ...typeFilter });
    setUrlParams({ ...typeFilter });
  };

  const setUrlParams = ({ ...typeFilter }) => {
    history.push({
      search:
        '?' +
        new URLSearchParams({
          ...typeFilter,
        }).toString(),
    });
  };

  const history = useHistory();

  //End of Filter Block

  const containerRef = useRef(null);
  useOutsideDrop(containerRef, () => {
    setFilterOpen(false);
    //  setClientFilterOpen(false);
    //  setFlowFilterOpen(false);
  });

  //Selector
  const flows = useSelector((state) => state.finishedFlows);
  const { status, pages, pagination } = flows;

  useVerifyToken(); // Garantiir Login
  // Reducer Fetch
  const dispatch = useDispatch();

  async function fetchingFinishedFlows() {
    trackPromise(
      dispatch(
        fetchFinishedFlows({
          queries: {
            filters: {
              title: typeFilter.title,
              client: typeFilter.client,
              alpha: typeFilter.alpha,
              creation: typeFilter.creation,
            },
          },
          page: typeFilter.page,
        })
      ).then((res) => {
        if (res?.error) {
          toastAlert({
            msg: `Ocorreu um erro ao carregar os projetos: '${res.payload.error}'`,
            isError: true,
          });
        }
      }),
      'fetchFinishedFlows'
    );
  }

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      fetchingFinishedFlows();
    }

    return () => (isMounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeFilter]);

  return (
    <TopDiv>
      <Menu />
      <MainContainer>
        <TopBar text="Fluxos Finalizados" />
        <ContainerCenter>
          <ContainerCenterInside>
            <Header>
              <InputDiv>
                <Input
                  Icon={() => <Search />}
                  value={labelSearch}
                  setValue={setLabelSearch}
                  placeholder="Pesquisar por Fluxo..."
                  buttonConfirm
                  buttonConfirmText="Pesquisar"
                  onClickButton={() => {
                    updateFilters({ ...typeFilter, title: labelSearch });
                  }}
                />
              </InputDiv>
              <FinishedFlowsFilter
                open={filterOpen}
                setOpen={setFilterOpen}
                type={typeFilter}
                setType={updateFilters}
                clientSearch={clientSearch}
                setClientSearch={setClientSearch}
                flowSearch={flowSearch}
                setFlowSearch={setFlowSearch}
              />
            </Header>
            {!isFetching && pagination.length > 0 ? (
              pagination.map((item, index) => (
                <ActiveIterable
                  onClick={() =>
                    history.push({
                      pathname: '/workflow/',
                      state: 'active',
                      search:
                        '?' +
                        new URLSearchParams({
                          flowId: item._id,
                        }).toString(),
                    })
                  }
                  key={index}
                  index={index}
                  title={item.title} // Certo
                  status={item.status} // a ser requisitado
                  startDate={item.createdAt} // Certo At Luxon
                  endDate={item.finishedAt} // Certo At Luxon
                  client={item.client} // Certo
                  responsibles={item.responsibles} // a ser implementado
                  description={item.description} // Certo
                  flowId={item._id} // Certo
                  reload={() => fetchingFinishedFlows(typeFilter.page)}
                  relatedUsers={item.relatedUsers}
                />
              ))
            ) : !isFetching && pagination.length === 0 ? (
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '1rem',
                }}
              >
                Nenhum fluxo encontrado com os filtros escolhidos
              </span>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '1rem',
                }}
              >
                <ReactLoading type="bars" color="#118052" />
              </div>
            )}
          </ContainerCenterInside>
        </ContainerCenter>
      </MainContainer>
      <Pagination
        style={{
          position: 'absolute',
          bottom: '1.5rem',
          left: '50%',
        }}
        actualPage={typeFilter.page}
        onPageChange={(activePage) => {
          updateFilters({
            ...typeFilter,
            page: activePage,
          });
        }}
        numberOfPages={pages}
      />
    </TopDiv>
  );
};

export default FinishedFlowsPage;
